/* Colour is assigned by role and never reused across roles. `warning` is a reporting-cadence caution; `stale` is a plain connectivity lapse. */
export const HEX = {
  healthy: "#10b981",
  warning: "#fab219",
  stale: "#ec835a",
  critical: "#d03b3b",
  neutral: "#94a3b8",
} as const;

/** Shared shell for every tile: one surface, one radius, one hairline. */
export const TILE_CLASS =
  "rounded-xl border-border bg-card shadow-[0_1px_2px_rgba(16,24,40,0.04)]";
